// Default site identity used while no API is configured (preview mode) and as
// the fallback for any field the backend has not overridden yet.
export const siteSettings = {
  siteName: "Mysore Yellow Pages",
  tagline: "Your hyperlocal business directory for Mysore & beyond",
  logoUrl:
    "https://public.readdy.ai/ai/img_res/8b2e690d-6858-4713-8bc0-7beb77d60bf0.png",
  logoDarkUrl:
    "https://public.readdy.ai/ai/img_res/f361fa65-1119-4c01-958f-b4124f2426ed.png",
  faviconUrl: "https://public.readdy.ai/ai/img_res/edited_81f81b684a1146a3b8639a7e62c8e7a0_fc779e29.jpg",
  ogImageUrl:
    "https://readdy.ai/api/search-image?query=Wide%20social%20share%20banner%20for%20a%20hyperlocal%20business%20directory%20brand%2C%20an%20elegant%20abstract%20cityscape%20of%20shopfronts%20and%20a%20map%20pin%20on%20a%20deep%20navy%20background%20with%20warm%20gold%20accents%2C%20refined%20minimal%20editorial%20composition%20with%20generous%20empty%20space%20for%20a%20headline%2C%20high%20detail%2C%20harmonious&width=1200&height=630&seq=myyp-og-default&orientation=landscape",
  contactEmail: "mysoreyellowpages@gmail.com",
  contactPhone: "+91 81235 84806",
  gstin: "GST awaited",
  address: "6th Main, E&F Block, Ramakrishna Nagar, Chaduranga Road, Mysore, Karnataka 570023",
  currency: "INR (₹)",
  timezone: "Asia/Kolkata (IST)",
  autoApproveListings: false,
  reviewsModeration: true,
  maintenanceMode: false,
  showPopularCategories: true,
  marqueeSpeed: 32,
  alertAdminOnLead: true,
  alertOwnerOnEnquiry: true,
  leadDigestEnabled: false,
  adminAlertRecipients: "",
  social: {
    facebook: "https://facebook.com",
    instagram: "https://instagram.com",
    x: "https://x.com",
    linkedin: "https://linkedin.com",
    youtube: "https://youtube.com",
  },
};